import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Button from 'react-bootstrap/Button';
import { AiOutlineDownload } from 'react-icons/ai';
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

function GoogleDocsToPdf() {
  const [width, setWidth] = useState(window.innerWidth);
  const [pageCount] = useState(2);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);

    convertToPdf();

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const [pdfUrl, setPdfUrl] = useState('');

  const convertToPdf = async () => {
    try {
      const documentUrl =
        'https://docs.google.com/document/d/1iQeJhN8m385te6a_1dczc6k_yMq36GHFfd8IJU8TPK4/export?format=pdf';

      const response = await axios.get(documentUrl, {
        responseType: 'blob',
      });

      if (response.status === 200) {
        const pdfBlob = new Blob([response.data], { type: 'application/pdf' });
        const pdfUrl = URL.createObjectURL(pdfBlob);
        setPdfUrl(pdfUrl);
      } else {
        console.error('Failed to convert to PDF');
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const isMobile = () => width <= 768; // Adjust breakpoint as needed

  return (
    <div>
      {pdfUrl && (
        <div className="DocumentPDF">
          <Button
            variant="primary"
            href={pdfUrl}
            target="_blank"
            className="downloadresume"
          >
            <AiOutlineDownload />
            &nbsp;Download Resume
          </Button>
          <Document
            file={pdfUrl}
            className={isMobile() ? 'mobile-pdf' : 'web-pdf'}
          >
            {Array.from({ length: pageCount }, (_, i) => (
              <Page
                key={i}
                pageNumber={i + 1}
                scale={isMobile() ? 0.7 : 1.2} // Adjust scale for mobile and larger screens
                customTextRenderer={(textItem) => null}
              />
            ))}
          </Document>
        </div>
      )}
    </div>
  );
}

export default GoogleDocsToPdf;
